var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { LocalStorageKeyEnum } from 'src/reference-data/local-storage-key.enum';
import LocalStorageUtils from 'src/utils/localStorage.utils';
const isEmpty = (activeAccount) => {
    return (!activeAccount.account || Object.keys(activeAccount.account).length === 0);
};
/* istanbul ignore next */
const saveActiveAccountNameInLocalStorage = (activeAccountName) => {
    LocalStorageUtils.saveValueInLocalStorage(LocalStorageKeyEnum.ACTIVE_ACCOUNT_NAME, activeAccountName);
};
/* istanbul ignore next */
const getActiveAccountNameFromLocalStorage = () => __awaiter(void 0, void 0, void 0, function* () {
    const account = yield LocalStorageUtils.getValueFromLocalStorage(LocalStorageKeyEnum.ACTIVE_ACCOUNT_NAME);
    return account && account.length ? account : undefined;
});
const removeAuthorizedAccount = (activeAccount, role, authorizedAccountName) => {
    const updatedActiveAccount = Object.assign({}, activeAccount);
    updatedActiveAccount.account[role] = Object.assign(Object.assign({}, updatedActiveAccount.account[role]), { account_auths: updatedActiveAccount.account[role].account_auths.filter((auth) => auth[0] !== authorizedAccountName) });
    return updatedActiveAccount;
};
const ActiveAccountUtils = {
    isEmpty,
    saveActiveAccountNameInLocalStorage,
    getActiveAccountNameFromLocalStorage,
    removeAuthorizedAccount,
};
export default ActiveAccountUtils;
